import React from "react";
import { cn } from "../../lib/utils";

export function PageHeader({
  title,
  description,
  icon: Icon,
  actions,
  className,
  compact = false,
}) {
  return (
    <div
      className={cn(
        "flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between",
        className,
      )}
    >
      <div className="min-w-0">
        <div className="flex items-center gap-3">
          {Icon ? (
            <Icon
              className={cn(
                "shrink-0 text-[#E2B05E]",
                compact ? "h-6 w-6" : "h-7 w-7 sm:h-8 sm:w-8",
              )}
            />
          ) : null}
          <h1
            className={cn(
              "min-w-0 break-words font-['Outfit'] font-semibold text-[#F3F4F6]",
              compact ? "text-2xl" : "text-2xl sm:text-3xl",
            )}
          >
            {title}
          </h1>
        </div>
        {description ? (
          <p className="mt-1 max-w-3xl text-sm leading-6 text-[#9CA3AF]">
            {description}
          </p>
        ) : null}
      </div>
      {actions ? (
        <div className="flex shrink-0 flex-wrap items-center gap-2 sm:justify-end">
          {actions}
        </div>
      ) : null}
    </div>
  );
}

export default PageHeader;
